import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ObjNgFor } from './objectNgFor.pipe';

import { HttpService } from './http.service';
import { AuthGuard } from './authGuard.service';
import { SharedService } from './shared.service';

const providerPackages = [
  HttpService,
  SharedService,
  AuthGuard
];
const modulePackages = [
  HttpClientModule,
  FormsModule,
  CommonModule,
  RouterModule,
];

@NgModule({
  imports: modulePackages,
  exports: [
    ...modulePackages
    , ObjNgFor
  ],
  declarations: [
    ObjNgFor
  ]
})
export class SharedModule {
  public static forRoot() {
    return {
      ngModule: SharedModule,
      providers: providerPackages
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts